import * as types from "../types/actionTypes";
import utils from "../../universal/utils";
import * as cookieStorage from "./common/cookieStorage";

const cStorage = cookieStorage.getCookieStorage();

const basePath = utils.getEdgeBasePath();

export function addToDepositCart(ean, isSet = false, isAtvSet = false) {
  return {
    type: types.ADD_TO_DEPOSIT_CART,
    ean,
    isSet,
    isAtvSet,
  };
}

export function removeFromDepositCart(ean) {
  return {
    type: types.REMOVE_FROM_DEPOSIT_CART,
    ean,
  };
}

export function updateDepositQuantity(ean, quantity) {
  return {
    type: types.UPDATE_DEPOSIT_QUANTITY,
    ean,
    quantity,
  };
}

export function clearDepositCart() {
  return {
    type: types.CLEAR_DEPOSIT_CART,
  };
}

/**
 * Fetch deposit preview (bracket-determined amount) for the current deposit cart.
 */
export function getDepositPreview(cart) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/deposit/preview`, {
      body: JSON.stringify({ cart }),
      headers: { "content-type": "application/json" },
      method: "POST",
      mode: "cors",
    })
      .then((res) => res.json())
      .then((result) => {
        dispatch({
          type: types.DEPOSIT_PREVIEW_LOADED,
          result,
        });
      })
      .catch((err) => {
        console.error("Deposit preview error:", err);
      });
  };
}

/**
 * Submit a deposit checkout order.
 */
export function submitDepositOrder(cart, checkout) {
  const stats = cStorage.getObject("stats");
  const { visitorId } = stats || {};

  const cleanCheckout = Object.assign({}, checkout, { visitorId });
  delete cleanCheckout.cities;
  delete cleanCheckout.shops;
  delete cleanCheckout.dates;
  delete cleanCheckout.slots;

  return function (dispatch) {
    dispatch({ type: types.DEPOSIT_CHECKOUT_LOADING });

    fetch(`${basePath}/api/v1/deposit/checkout`, {
      body: JSON.stringify({ cart, checkout: cleanCheckout }),
      cache: "no-cache",
      headers: { "content-type": "application/json" },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    })
      .then((res) => {
        if (!res.ok) {
          console.error("[deposit/checkout] Server returned status:", res.status);
        }
        return res.json();
      })
      .then((result) => {
        console.log("[deposit/checkout] Response:", JSON.stringify(result));
        if (result.success && result.redirectUrl) {
          // Redirect to CreditGuard
          window.location.href = result.redirectUrl;
        } else {
          dispatch({
            type: types.DEPOSIT_CHECKOUT_ERROR,
            result: { reason: result.reason || result.message || "Server returned an unexpected response" },
          });
        }
      })
      .catch((err) => {
        console.error("[deposit/checkout] Fetch error:", err);
        dispatch({
          type: types.DEPOSIT_CHECKOUT_ERROR,
          result: { reason: err.message || "Network error" },
        });
      });
  };
}

/**
 * Finalize deposit payment after returning from CreditGuard.
 */
export function finalizeDeposit(params) {
  return function (dispatch) {
    const stats = cStorage.getObject("stats");
    const { visitorId } = stats || {};

    fetch(`${basePath}/api/v1/deposit/finalize`, {
      body: JSON.stringify({ ...params, visitorId }),
      headers: { "content-type": "application/json" },
      method: "POST",
      mode: "cors",
    })
      .then((res) => res.json())
      .then((result) => {
        dispatch({
          type: types.DEPOSIT_FINALIZE_RESULT,
          result,
        });
        // Clear the deposit cart on successful finalization
        if (result.ok) {
          dispatch({ type: types.CLEAR_DEPOSIT_CART });
        }
      })
      .catch((err) => {
        dispatch({
          type: types.DEPOSIT_FINALIZE_RESULT,
          result: { ok: false, reason: err.message },
        });
      });
  };
}

/**
 * Look up a deposit order by orderId + completionCode.
 */
export function lookupDepositOrder(orderId, completionCode) {
  return function (dispatch) {
    dispatch({ type: types.DEPOSIT_LOOKUP_LOADING });

    fetch(`${basePath}/api/v1/deposit/lookup`, {
      body: JSON.stringify({ orderId: parseInt(orderId), completionCode }),
      headers: { "content-type": "application/json" },
      method: "POST",
      mode: "cors",
    })
      .then((res) => res.json())
      .then((result) => {
        dispatch({
          type: types.DEPOSIT_LOOKUP_RESULT,
          result,
        });
      })
      .catch((err) => {
        dispatch({
          type: types.DEPOSIT_LOOKUP_RESULT,
          result: { ok: false, reason: err.message },
        });
      });
  };
}

/**
 * Initiate remainder payment.
 */
export function initiateRemainderPayment(orderId, completionCode) {
  return function (dispatch) {
    dispatch({ type: types.DEPOSIT_CHECKOUT_LOADING });

    fetch(`${basePath}/api/v1/deposit/remainder`, {
      body: JSON.stringify({ orderId: parseInt(orderId), completionCode }),
      headers: { "content-type": "application/json" },
      method: "POST",
      mode: "cors",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.ok && result.redirectUrl) {
          window.location.href = result.redirectUrl;
        } else {
          dispatch({
            type: types.DEPOSIT_CHECKOUT_ERROR,
            result,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: types.DEPOSIT_CHECKOUT_ERROR,
          result: { reason: err.message },
        });
      });
  };
}

/**
 * Finalize remainder payment after CreditGuard redirect.
 */
export function finalizeRemainderPayment(params) {
  return function (dispatch) {
    const stats = cStorage.getObject("stats");
    const { visitorId } = stats || {};

    fetch(`${basePath}/api/v1/deposit/remainder/finalize`, {
      body: JSON.stringify({ ...params, visitorId }),
      headers: { "content-type": "application/json" },
      method: "POST",
      mode: "cors",
    })
      .then((res) => res.json())
      .then((result) => {
        dispatch({
          type: types.DEPOSIT_REMAINDER_FINALIZE_RESULT,
          result,
        });
      })
      .catch((err) => {
        dispatch({
          type: types.DEPOSIT_REMAINDER_FINALIZE_RESULT,
          result: { ok: false, reason: err.message },
        });
      });
  };
}
